import React, { useState } from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

function ConnectWithAgentStep() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 4;

  const [formData, setFormData] = useState({
    // Step 1
    email: "",
    // Step 2
    phoneNumber: "",
  });

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    navigate("/");
  };


  return (
    <>
      <div className="main connect-agent-step-page">
        <Header />
        <CommonBanner title="Your Team" />
        <section className="agent-form-section common-padding">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} sm={12}>
                {/* Form Card */}
                <div className="form-card">
                  <form onSubmit={handleSubmit}>
                    {/* Step 1: Email */}
                    {currentStep === 1 && (
                      <div className="form-step">
                        <h3 className="step-title">Getting started is easy</h3>
                        <p className="step-description">Put your email address below to connect with a local agent.<br/> You can rest assured that we’ll keep any information you share secure.</p>

                        <Form.Group className="mb-4">
                          <Form.Control
                            type="email"
                            placeholder="Your email address"
                            value={formData.email}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                email: e.target.value,
                              })
                            }
                            required
                          />
                        </Form.Group>

                        <Button
                          className="custom-bttn style-3 w-100"
                          onClick={handleNext}
                          type="button"
                        >
                          Continue
                        </Button>
                      </div>
                    )}

                    {/* Step 2: Location */}
                    {currentStep === 2 && (
                      <div className="form-step">
                        <h3 className="step-title">We'll reach out first via text</h3>
                        <p className="step-description">Enter your number below and we’ll send you a text to<br/> connect at a time that works for you.</p>

                        <Form.Group className="mb-4">
                          <Form.Control
                            type="text"
                            placeholder="Phone number"
                            value={formData.phoneNumber}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                location: e.target.value,
                              })
                            }
                            required
                          />
                        </Form.Group>

                        <Button
                          className="custom-bttn style-3 w-100"
                          onClick={handleNext}
                          type="button"
                        >
                         Next
                        </Button>

                        <Button
                          variant="link"
                          className="back-link w-100"
                          onClick={handlePrevious}
                          type="button"
                        >
                          Go Back
                        </Button>
                      </div>
                    )}

                    {/* Step 3: Name */}
                    {currentStep === 3 && (
                      <div className="form-step">
                        <h3 className="step-title">One last step</h3>
                        <p className="step-description">For confirmation, do you agree to be contacted by<br/> Real Estate and a local real estate agent?</p>

                        <Button
                          className="custom-bttn style-3 w-100"
                          onClick={handleNext}
                          type="button"
                        >
                          I agree
                        </Button>

                        <Button
                          variant="link"
                          className="back-link w-100"
                          onClick={handlePrevious}
                          type="button"
                        >
                          Go Back
                        </Button>
                         <p className="disclaimer-text">By pressing “I agree”, you agree to our <Link to='/terms-of-use'>Terms of Use</Link> and that Real Estate Group, its affiliates, and the real estate professional you select via the button above may contact you about your search, which may involve recurring calls/text messages sent using an automatic telephone dialing system or prerecorded/artificial voices. Consent is not a condition of purchasing any property, goods, or services. Message/data rates may apply. Messaging frequency varies. Real Estate does not endorse any real estate professionals. We may share information about your recent and future site activity with your agent to help them understand what you’re looking for in a home. Visit our <Link to='/privacy-policy'>Privacy Policy</Link> for more information.</p>
                      </div>
                    )}

                    {/* Step 4: Phone */}
                    {currentStep === 4 && (
                      <div className="form-step">
                        <h3 className="step-title">We'll text you in a few minutes (we're that fast)</h3>
                        <p className="step-description">If you're busy, that's ok, just let us know via text when you're available to talk.</p>

                        <Button className="custom-bttn style-3 w-100" type="submit" >
                          Close and Continue
                        </Button>

                        <Button
                          variant="link"
                          className="back-link w-100"
                          onClick={handlePrevious}
                          type="button"
                        >
                          Go Back
                        </Button>
                      </div>
                    )}
                  </form>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default ConnectWithAgentStep;